export default __webpack_public_path__ + "static/media/brand_bbva.b6ea8b0f.svg";